import { Images } from "../../config";
import VisionAINavbar from "./navbar";
import VisionAISidebar from "./sidebar";

import "./styles.css";

const VisionAILayout = ({
  chat,
  setActiveSession,
  activeSession,
  profileData,
  sessionLoading = false,
  aiDocs,
  isDocsLoading,
  children,
}) => {
  return (
    <div
      className="relative flex flex-col text-black h-screen"
      style={{
        backgroundImage: `url(${Images.VisionAIBg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <VisionAINavbar
        profileData={profileData}
        aiDocs={aiDocs}
        isDocsLoading={isDocsLoading}
      />
      <VisionAISidebar
        chat={chat}
        setActiveSession={setActiveSession}
        activeSession={activeSession}
        loading={sessionLoading}
      />
      <div className="ml-[18.75em] overflow-scroll">{children}</div>
    </div>
  );
};

export default VisionAILayout;
